<template>
  <div>
    <va-card :class="{'closed': !expanded}">
      <template slot="header">
        <div class="d-flex align-items-center justify-content-between w-100">
          <h5 class="card-title">{{ $t(`audiology_4_all.titles.tests.${test.slug}`) }}</h5>
          <span v-if="expandable" @click.prevent="expanded = !expanded">
            <va-icon class="clickable" :name="expandIconClass" color="success"/>
          </span>
        </div>
      </template>

      <div v-show="expanded">
        <va-card v-for="item in test.subtests" :key="item.id">
          <div  v-if="item.slug !== 'tonalTestQuestionnaire'">
            <h6 class="is-bold mb-0">{{ $t(`audiology_4_all.titles.tests.${item.slug}`) }}</h6>
            <A4ASubtestTable
              :subtest="item"
              :account="account"
              :testSessionId="testSessionId"
              class="mb-2">
            </A4ASubtestTable>
          </div>
        </va-card>
      </div>
    </va-card>
  </div>
</template>

<script>
import TableQueryMixin from "@/mixins/TableQueryMixin";
import A4ASubtestTable from "@/components/clinical/accounts/AccountDetails/A4A/A4ASubtestTable";

export default {
  components: {A4ASubtestTable},
  props: {
    account: {
      type: Object,
      required: true
    },
    expandable: {
      type: Boolean,
      required: false,
      default: true
    },
    service: {
      type: Object,
      required: false
    },
    test: {
      type: Object,
      required: true,
      default: ''
    }
  },
  mixins: [
    TableQueryMixin
  ],
  data: function () {
    return {
      isOpen: false,
      expanded: true,
    }
  },
  computed: {
    a4aServiceUrl: function() {
      return `${process.env.VUE_APP_A4A_URL}/v1/tests`
    },
    expandIconClass: function () {
      return this.expanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
    }
  }
}
</script>

<style scoped>

</style>
